import { render, staticRenderFns } from "./ProfileTalentSection.vue?vue&type=template&id=2b2b2de2"
import script from "./ProfileTalentSection.vue?vue&type=script&lang=js"
export * from "./ProfileTalentSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports